module.exports = __webpack_public_path__ + "static/note_en-b0190c584c41df1ab0cbc0d840b5708c.jpg";